import Vue from 'vue'
import Router from 'vue-router'
import space from "../util/space"
const homepage = r => require.ensure([], () => r(require('@/components/homepage/homepage')))
const underhomepage1 = r => require.ensure([], () => r(require('@/components/homepage/underhomepage1')))
const underhomepage2 = r => require.ensure([], () => r(require('@/components/homepage/underhomepage2')))
const modelsinfo = r => require.ensure([], () => r(require('@/components/homepage/modelsinfo')))
const searchbox = r => require.ensure([], () => r(require('@/components/searchbox/searchmain')))
const photosmain = r => require.ensure([], () => r(require('@/components/photosbox/photosmain')))
const login = r => require.ensure([], () => r(require('@/components/login/login')))
const resetpass = r => require.ensure([], () => r(require('@/components/resetpass/resetpass')))
const androdown = r => require.ensure([], () => r(require('@/components/androdown/androdown')))
const model = r => require.ensure([], () => r(require('@/components/model/model')))
const userinfos = r => require.ensure([], () => r(require('@/components/userbyinfo/userbyinfo')))
const paylist = r => require.ensure([], () => r(require('@/components/userbyinfo/paylist')))
const subion = r => require.ensure([], () => r(require('@/components/userbyinfo/subion')))
const buylist = r => require.ensure([], () => r(require('@/components/userbyinfo/buylist')))
const coins = r => require.ensure([], () => r(require('@/components/userbyinfo/coins')))
const unsercenter = r => require.ensure([], () => r(require('@/components/userbyinfo/unsercenter')))
const switchlist = r => require.ensure([], () => r(require('@/components/userbyinfo/switchlist')))
const collection = r => require.ensure([], () => r(require('@/components/userbyinfo/collection')))
const regist = r => require.ensure([], () => r(require('@/components/regist/regist')))
const email = r => require.ensure([], () => r(require('@/components/regist/email')))
const phonesignup = r => require.ensure([], () => r(require('@/components/regist/phoneregist')))
const modelinfo = r => require.ensure([], () => r(require('@/components/photosbox/modelinfo')))
const getemail = r => require.ensure([], () => r(require('@/components/resetpass/getemail')))
const emaiset = r => require.ensure([], () => r(require('@/components/resetpass/emaiset')))
const codes = r => require.ensure([], () => r(require('@/components/resetpass/code')))
const err404 = r => require.ensure([], () => r(require('@/components/glocompoen/errors')))
const cohsectry = r => require.ensure([], () => r(require('@/components/regist/cohsectry')))
const Agreement = r => require.ensure([], () => r(require('@/components/regist/Agreement')))
const regisuccess = r => require.ensure([], () => r(require('@/components/glocompoen/regisuccess')))
const only_img = r => require.ensure([], () => r(require('@/components/glocompoen/only_img')))
const simple = r => require.ensure([], () => r(require('@/components/glocompoen/simple')))


const pay_success_or_fail = r => require.ensure([], () => r(require('@/components/paysuccessorfail/pay_success_or_fail')))
//GA 统计
Vue.use(Router)
export default new Router({
  //滚动的位置记录
  mode:'history',
  routes: [
    {
      path: '/',
      // name: 'homepage',
      component: homepage,
      children: [{
        path: '',
        name:"underhomepage1",
        component: underhomepage1,
        meta: {
          keepAlive: true, // 需要被缓存
          keywords:"PureBabe, cute girl pics, hot girl photos,sexy photos , sexy modeling, cute girl pics, hot girl photos, hd girl photo galleries"
        },
      },
      {
        path:'galleries/:name/:id//',
        name:"underhomepage2",
        props:true,
        component: underhomepage2,
        alias:'garylis',
      },
      {
        path: 'reset-password//',
        name: 'resetpass',
        component: resetpass
      },
      {
        path: 'app//',
        name: 'androdown',
        component: androdown
      },
      {
        path: 'models//',
        name: 'model',
        component: model,
        meta: {
          keepAlive: true // 需要被缓存
        }
      },
      {
        path:"models/:name/:id//",
        name:"modelsinfo",
        component:modelsinfo,
      },
      {
        path: 'me',
        //name: 'userinfo',
        component: userinfos,
        children: [
          // {
          //   path: "profile//",
          //   name:"user",
          //   component:unsercenter
          // },
          {
            path: "liked//",
            name:"collection",
            component:collection
          },
          {
            path: "purchased//",
            name:"Purchased",
            component:collection
          },
          
          {
            path: "/",
            component: switchlist,
            children: [
              {
                path: 'payment-subscribe/:types/:showa//',
                component: paylist,
                name:"paylist"
              },
              {
                path: 'buylist/:types/:showa//',
                name:"buylist",
                component: buylist
              },
              {
                path: 'membership-subcribe/:types/:showa//',
                name:'subion',
                component: subion

              },
              {
                path: 'membership-coins/:types/:showa//',
                name:"coins",
                component: coins
              }
            ]
          },
          {
            path: 'unsercenter//',
            name:"unsercenter",
            component: unsercenter
          },
        ]
      }
      ]
    },
    {
      name:"only_img",
      component:only_img,
      path:"/one_img"
    },
    {
      name:"simple",
      component:simple,
      path:"/simple"
    },
    
    {
      name:"emailregisuccess",
      component:regisuccess,
      path:"/emailregisuccess//",
    },
    {
      name:"phoneregisuccess",
      component:regisuccess,
      path:"/phoneregisuccess//",
    },
    {
      name:"pay_success",
      component:pay_success_or_fail,
      path:"/paymentsuccess//",
    },
    {
      name:"pay_fail",
      component:pay_success_or_fail,
      path:"/paymentfail//",
    },
    {
      //自定义
      path: "/emaisetpass",
      name:"getemail",
      component:getemail,
      children:[
        {
          path:'emaiset//',
          name:'emaiset',
          component:emaiset
        },
        {
          path:'codes//',
          name:'codes',
          component:codes
        }
      ]
    },
    {
      path: '/search//',
     // query:{keyword:''},
      name: 'search',
      component: searchbox,
    },
    {
      path: '/',
      //name: 'phonts',
      component: photosmain,
      children:[
        {
          path:'galleries//',
          component:modelinfo,
          name:"modelinfo"
        }
      ],
      meta:{
        keepAlive:true
      }
    },
    {
      path: '/login//',
      name: 'login',
      component: login,
    },
    {
      path:"/",
      component:regist,
      //name:"regist",
      children:[
        {
          name:"emailsignup",
          component:email,
          path:'emailsignup//'
        },
        {
          name:"phonesignup",
          component:phonesignup,
          path:'phonesignup//'
        },
        {
          name:"cohsectry",
          component:cohsectry,
          path:"cohsectry//",
        }
      ]
    },
    {
      name:"agreement",
      component:Agreement,
      path:"agreement//",
      meta:{
        title:'agreement'
      }
    },
    {
      path: "*",
      redirect:{
       name:'underhomepage1'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js